import { When } from 'react-if';
import { useTranslation } from 'next-i18next';
import { OperationType } from '../../../../types/SubscriptionType';
import { NextClaimDate, PaymentMethods, PaymentPrice, ZipCode } from '../components';
import { usePlanSpaceDetailContext } from '../plan';
import { PlanSpacesSection } from '../space/organisms';
export const ManagePay = () => {
  const {
    t
  } = useTranslation(['subscription']);
  const {
    space,
    subscription,
    spacePlan
  } = usePlanSpaceDetailContext();
  return <PlanSpacesSection title={t('subscription:SpaceList.button.toManage')} data-sentry-element="PlanSpacesSection" data-sentry-component="ManagePay" data-sentry-source-file="ManagePay.tsx">
      <PaymentMethods data-sentry-element="PaymentMethods" data-sentry-source-file="ManagePay.tsx" />
      <When condition={!(space?.countryCode === 'KR' || space?.countryCode === 'JP') && spacePlan?.operationType !== OperationType.일시납 && spacePlan?.operationType !== OperationType.커스텀_일시납} data-sentry-element="When" data-sentry-source-file="ManagePay.tsx">
        <ZipCode data-sentry-element="ZipCode" data-sentry-source-file="ManagePay.tsx" />
      </When>
      <When condition={subscription?.requestedAction !== 'UNSUBSCRIBE'} data-sentry-element="When" data-sentry-source-file="ManagePay.tsx">
        <NextClaimDate title={t('subscription:SpaceDetail.menuManage.nextPaymentDate')} data-sentry-element="NextClaimDate" data-sentry-source-file="ManagePay.tsx" />
      </When>
      <PaymentPrice data-sentry-element="PaymentPrice" data-sentry-source-file="ManagePay.tsx" />
    </PlanSpacesSection>;
};